import de from './de.json';
import en from './en.json';

const graphsLocales = { en, de };

export default graphsLocales;
